import * as React from 'react';

const UserMenuIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
        <path stroke="#7D61A7" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M24 26.667a8 8 0 0 0-16 0" />
        <path
            stroke="#7D61A7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M16 18.667A5.333 5.333 0 1 0 16 8a5.333 5.333 0 0 0 0 10.667Z"
        />
        <path
            stroke="#7D61A7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M16 29.334c7.363 0 13.333-5.97 13.333-13.334 0-7.363-5.97-13.333-13.334-13.333C8.636 2.667 2.666 8.637 2.666 16c0 7.364 5.97 13.334 13.333 13.334Z"
        />
    </svg>
);
export default UserMenuIcon;
